export const TEAM_ENDPOINT = 'api/teams';
export const AI_ENDPOINT = 'api/ai';
export const USER_ENDPOINT = 'api/users';
export const BILLING_ENDPOINT = 'api/billing';

//TODO: Replace with environment variable to support multiple environment
export const USER_AUTH_ENDPOINT = 'https://agentnest.auth0.com/api/v2/users';
